import { Address_Country as Country } from "gen/proto/address/models_pb"

import { useGetCompanyQuery } from "features/api/company"

export function useCountry() {
  const { data: getCompanyData, isLoading } = useGetCompanyQuery({})
  return {
    country: getCompanyData?.company?.country ?? Country.US,
    isLoading,
  }
}
